<div class="toaster"
     [ngClass]="getToasterClass()"
     [@slideIn]
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()"
     (click)="onToasterClick($event)"
     [class.clickable]="hasClickAction()">

  <!-- Progress bar on top -->
  <div class="toaster-progress">
    <div class="toaster-progress-bar"
         [style.width.%]="progressWidth"
         [class.paused]="isPaused"></div>
  </div>

  <!-- Toaster content -->
  <div class="toaster-content">
    <!-- Icon -->
    <div class="toaster-icon">
      <ng-icon [name]="getIconName()"></ng-icon>
    </div>

    <!-- Message -->
    <div class="toaster-message">
      <div class="toaster-title">{{ toaster.title }}</div>
      <div class="toaster-text">{{ toaster.message }}</div>
    </div>

    <!-- Close button -->
    <button class="toaster-close"
            (click)="onDismiss()"
            type="button"
            aria-label="Close">
      <ng-icon name="tablerX"></ng-icon>
    </button>
  </div>
</div>
